import React from 'react'
import AIAnalysis from '../components/dashboard/AIAnalysis'
import { useUser } from '../context/UserContext'
import { ReportPage } from '../components/report-shell'

const AIAnalysisPage = () => {
  const { hasFeatureAccess } = useUser()

  if (!hasFeatureAccess('AI_ANALYSIS')) {
    return (
      <ReportPage title="Analiza AI" subtitle="Brak dostępu" breadcrumb={['KAM-SFA', 'Analiza AI']}>
        <div style={{
          padding: 24, borderRadius: 10,
          background: '#fee2e2', border: '1px solid #fecaca',
          color: '#991b1b',
        }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>Brak dostępu</div>
          <div style={{ fontSize: 13 }}>
            Nie masz uprawnień do modułu Analiza AI. Skontaktuj się z administratorem aby uzyskać dostęp.
          </div>
        </div>
      </ReportPage>
    )
  }

  return (
    <ReportPage>
      <AIAnalysis />
    </ReportPage>
  )
}

export default AIAnalysisPage
